export function RestoreBookedBets(method, params, headers, baseUrl, endpoint) {
    return new Request(`${baseUrl}${endpoint}${params.token}`, {
        method,
        headers
    });
}
//# sourceMappingURL=RestoreBookedBets.js.map